import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const SIZE = {
    body: 'text-[length:var(--fs-ui-body)]',
    meta: 'text-[length:var(--fs-ui-meta)]'
};
/** Word-level difference between two versions, drawn inline. */ export const SpecraDiffText = /*#__PURE__*/ React.forwardRef(({ className, segments, size = 'body', ...props }, ref)=>{
    if (segments.length === 0) return null;
    // A diff is a fixed sequence without ids: each segment's character offset
    // in the combined text is its identity.
    const nodes = [];
    let at = 0;
    for (const segment of segments){
        const key = `${at}:${segment.op}`;
        at += segment.text.length;
        if (segment.op === 'insert') {
            nodes.push(/*#__PURE__*/ _jsxs("ins", {
                className: "rounded-[var(--radius-xs)] bg-[var(--color-diff-insert-bg)] text-[color:var(--color-diff-insert-fg)] underline decoration-1 underline-offset-2",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "sr-only",
                        children: "inserted: "
                    }),
                    segment.text
                ]
            }, key));
        } else if (segment.op === 'delete') {
            nodes.push(/*#__PURE__*/ _jsxs("del", {
                className: "rounded-[var(--radius-xs)] bg-[var(--color-diff-delete-bg)] text-[color:var(--color-diff-delete-fg)] line-through decoration-1",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "sr-only",
                        children: "deleted: "
                    }),
                    segment.text
                ]
            }, key));
        } else {
            nodes.push(/*#__PURE__*/ _jsx(React.Fragment, {
                children: segment.text
            }, key));
        }
    }
    return /*#__PURE__*/ _jsx("span", {
        className: cn('whitespace-pre-wrap leading-[var(--lh-snug)] text-foreground', SIZE[size], className),
        ref: ref,
        ...props,
        children: nodes
    });
});
SpecraDiffText.displayName = 'SpecraDiffText';
